import Link, { navigate } from 'gatsby-link';
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { MixBlendDifference } from 'style';
import { MethodsService } from 'utils';
import { HeroImage, Media } from '..';

class NextCase extends PureComponent {
    constructor(props) {
        super(props);

        this.navigateToCase = this.navigateToCase.bind(this);
    }

    navigateToCase(event, slug) {
        let nextCaseImage = this.props.case.teaserImageWide;// this.getNextImage();
        event.preventDefault();
        MethodsService.getMethod('navigateWithTransition')(
            'toNextCase',
            <HeroImage
                image={nextCaseImage}
                fadein={false}
            />,
            this.box.getBoundingClientRect(),
            slug
        );
    }
    getNextImage() {
        let teaserImageWide = '';
        let module = this.props.hero.filter(el => {
            return el.__typename == 'DatoCmsHeroImage';
        });
        if (module.length) {
            teaserImageWide = module[0].image;
        }
        if (
            teaserImageWide.format == 'jpg' ||
            teaserImageWide.format == 'jpeg' ||
            teaserImageWide.format == 'png' ||
            teaserImageWide.format == 'gif'
        ) {
            return teaserImageWide;
        }
        return this.props.teaserImageWide;
    }
    render() {
        let text = 'Next project';
        let slug = '';
        let nextCaseImage = '';
        let animate = false;
        if (this.props.case != null) {
            slug = `/work/${this.props.case.slug}`;
            nextCaseImage = this.props.case.teaserImageWide;
            animate = true;
        }
        if (this.props.page != null) {
            text = this.props.text;
            slug = `/${this.props.page.slug}`;
            nextCaseImage = this.props.image;
            animate = false;
        }

        return (
            <div id="NextCaseComponent">
                <CustomLink
                    css={{ textDecoration: 'none' }}
                    to={slug}
                    onClick={event => animate == true ? this.navigateToCase(event, slug) : navigate(slug)}
                    data-cursor="hero"
                    data-cursor-persistance="200"
                    style={{ display: 'block', width: '100%' }}>
                    <Right css={col_css}>
                        <RightImage
                            image={nextCaseImage && nextCaseImage.url}
                            /*removed innerRef*/ ref={el => (this.box = el)}
                        >
                            <Text>{text}</Text><Media image={nextCaseImage} fadeIn={false} loop={true} />
                            <div className='preloadimage'>
                                {nextCaseImage && <Media image={nextCaseImage} fadeIn={false} />}
                            </div>
                        </RightImage>
                    </Right>
                </CustomLink>
            </div>
        );
    }
}

const Text = styled.h1`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 1;
  transform: translate(-50%,-50%);
  color: #fff;
  white-space: nowrap;
  text-decoration: none;
  ${MixBlendDifference}
`;

const col_css = css`
    flex: 1 0 300px;
    max-width: 100%;
    display: flex;
    @media (min-width: 1000px) {
    }

`;

const Right = styled.div`
    transition: height 0.2s;
    background-color: rgba(0, 0, 0, 0.1);
    display: block;
    position: relative;
    height: 56vh;

    @media (orientation: landscape){
      height: 36vw;
    }
`;

const RightImage = styled.div`
    background-image: url(${props => props.image});
    overflow: hidden;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;

    &.transition {
        transition: all 0.5s;
        position: absolute;
        z-index: 1;
        bottom: 0;
        height: 100vh;
    }
    /* .media{
        height: 100%;
    } */

    /* .react-player{
        video{
            height: auto;
            min-height: 100%;
        }
    } */


    .media{
      transition: transform 3s;

      transform: translateY(-50%);
      top: 50%;
      height: auto;
      min-width: 100%;
      min-height: 100%;

      /* video{
        width: auto !important;
        height: auto !important;
        min-height: 100%;
        min-width: 100%;
        max-width: inherit;
        left: 50%;
        top: 50%;
        position: absolute;
        transform: translate(-50%,-50%);
      } */
    }
    .media-image{
      display: none;
    }
    .preloadimage {
        width: 100%;
        height: 0;
        overflow: hidden;
    }
`;

const Left = styled.div`
    height: 50vh;
    transition: height 0.2s;
    position: relative;
    align-items: center;
    bottom: 0;
    background-color: ${props => props.invert ? '#000' : '#fff'};
    color: ${props => props.invert ? '#fff' : '#000'};
`;


const CustomLink = styled(Link)`
    text-decoration: none !important;
    @media screen{
      &:hover {
          .media{
            transform: translateY(-50%) scale(1.1);
          }
      }
    }
`;

export default NextCase;
